export default __webpack_public_path__ + "static/media/rating.776a9fcd.svg";